module.exports = __webpack_public_path__ + "public/img/zhuanpanchoujiang.7aafa35a.png";